import React from "react";
import styled from "styled-components";
import Navbar from "./shared/Navbar";
import Footer from "./shared/Footer";
import { Outlet } from "react-router-dom";

function AuthLayout() {
  return (
    <PageLayout>
      <Navbar />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </PageLayout>
  );
}

export default AuthLayout;

const Main = styled.main`
  flex: 1;
  background: rgb(241, 245, 249);
  display: flex;
  justify-items:center;
  align-items: center;
  justify-content: center;

`;

const PageLayout = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;
